// extracted by mini-css-extract-plugin
module.exports = {"loader":"loading_loader__3yZAM","load3":"loading_load3__1roZc","blackLoader":"loading_blackLoader__2zh7q"};